import { IOrderElement } from './../model/types'

const countNotPayedElements = (elements: IOrderElement[]): number => {
  const countElements: number = elements.reduce((acc: number, el: IOrderElement) => {
    return el.status === 'NOT_PAID' ? acc + 1 : acc + 0
  }, 0)
  return countElements
}

export default countNotPayedElements
